class DrawerMenu extends HTMLElement {
  constructor(){
    super();

    const menus = this.querySelectorAll('[data-menu]');

    const showNext = (e) => {
      const current = e.target.nextElementSibling;
      const parent = e.target.closest('[data-menu]');
      const grandparent = parent.parentElement.closest('[data-menu]');
      if (!current) return;

      menus.forEach((m) => m.classList.remove('active'));
      grandparent?.classList.add('active');
      parent?.classList.add('active');
      current.classList.add('active');
    }

    const showPrevious = (e) => {
      const parent = e.target.closest('[data-menu]');
      if (!parent) return;
      parent.classList.remove('active');
    }

    const navBtns = this.querySelectorAll('[data-nav]');
    navBtns.forEach((btn) => {
      btn.addEventListener('click', showNext);
    });

    const returnBtns = this.querySelectorAll('[data-return');
    returnBtns.forEach((btn) => {
      btn.addEventListener('click', showPrevious);
    });
  }
}

customElements.define('drawer-menu', DrawerMenu);